import { StructuredPrompt } from "../../../../../models/structured-prompt";
import { CanvasObject } from "../types";

export const parseStructuredPrompt = (structuredPrompt: string | StructuredPrompt | undefined): CanvasObject[] => {
	if (!structuredPrompt) return [];

	try {
		const parsed: StructuredPrompt =
			typeof structuredPrompt === "string" ? JSON.parse(structuredPrompt) : structuredPrompt;

		if (!parsed.objects?.length) return [];

		// Map with original index, then filter, preserving original indices
		const objectsWithIndex = parsed.objects.map((obj, originalIndex) => ({ obj, originalIndex }));
		const filtered = objectsWithIndex.filter(({ obj }) => obj.bounding_boxes?.[0] && obj.colors?.length);

		return filtered.map(({ obj, originalIndex }, filteredIndex) => {
			const bbox = obj.bounding_boxes![0];

			return {
				id: `object-${filteredIndex}`,
				originalIndex, // Store original index for syncing back to structured prompt
				layerKey: null as null,
				name: obj.description,
				bbox: {
					left: bbox.top_left.x,
					top: bbox.top_left.y,
					width: bbox.bottom_right.x - bbox.top_left.x,
					height: bbox.bottom_right.y - bbox.top_left.y,
				},
				colors: obj.colors!.map((c) => ({ r: c.red, g: c.green, b: c.blue })),
			};
		});
	} catch (error) {
		console.error("Failed to parse structured prompt:", error);
		return [];
	}
};
